/**
 * ui/ — the CRM's shared UI kit. Screens import from here, never from 'antd' directly
 * (enforced by the no-restricted-imports lint rule in client/package.json), so the
 * look of every screen can be changed in one place.
 *
 *   import { Page, PageHeader, FilterBar, FilterField, DataTable, RowActions, … } from '../../ui';
 *
 * Building blocks (each file has a header comment with props + usage):
 *   UiProvider     theme + RTL + Hebrew, wraps the app            UiProvider.js
 *   AppLayout      side menu + top bar shell                       AppLayout.js
 *   Page/PageHeader  page frame + title row                        Page.js
 *   Section        white card with a title                         Section.js
 *   FilterBar/FilterField  search & filter card                    FilterBar.js
 *   DataTable      every list/table                                DataTable.js
 *   RowActions     icon buttons at the end of a row                RowActions.js
 *   BulkActionBar  floating bar for selected rows                  BulkActionBar.js
 *   EditDrawer     side panel editor with save bar + dirty guard   EditDrawer.js
 *   FormGrid/Field 2-column form layout                            FormGrid.js
 *   StatusBadge/TagChips/softColor  data labels                    Badges.js
 *   EmptyState     "nothing here" states                           EmptyState.js
 *   lookups        statuses/tags lists for Selects                 lookups.js
 *   useWhatsappStatus  shared WhatsApp connection status          whatsappStatus.js
 *   StatCard/Metric/MetricRow/Meter/StatusDot  dashboard pieces    Metrics.js
 *   tokens         raw design values                               theme.js
 *
 * Plain Ant Design controls (Button, Input, Select, DatePicker, Switch, Modal, Tooltip,
 * Dropdown, Segmented, Popconfirm, Progress …) are re-exported below so screens get them from one place too.
 * Icons come from '@ant-design/icons' directly.
 */
import { Grid } from 'antd';

export { default as UiProvider } from './UiProvider';
export { default as AppLayout } from './AppLayout';
export { Page, PageHeader } from './Page';
export { default as Section } from './Section';
export { default as FilterBar, FilterField } from './FilterBar';
export { default as DataTable } from './DataTable';
export { default as RowActions } from './RowActions';
export { default as BulkActionBar } from './BulkActionBar';
export { default as EditDrawer } from './EditDrawer';
export { FormGrid, Field } from './FormGrid';
export { StatusBadge, TagChips, softColor } from './Badges';
export { default as EmptyState } from './EmptyState';
export * from './lookups';
export { useWhatsappStatus } from './whatsappStatus';
export { StatCard, Metric, MetricRow, Meter, StatusDot } from './Metrics';
export { tokens } from './theme';

// Responsive helper: const screens = useBreakpoint(); screens.md === false → phone layout
export const useBreakpoint = Grid.useBreakpoint;

// Plain Ant Design controls, re-exported (see note above).
export {
  Button,
  Input,
  Select,
  DatePicker,
  Switch,
  Modal,
  Tooltip,
  Dropdown,
  Space,
  Spin,
  Segmented,
  Popconfirm,
  ColorPicker,
  Tabs,
  Radio,
  Checkbox,
  InputNumber,
  Progress,
  Popover,
  AutoComplete,
  Typography,
  message,
} from 'antd';
